/* Amoria "Track your order" page. Talks only to our own lookup (/apps/amoria-track via the
   Shopify app proxy). Real dates come from Shopify; anything date-based is labeled as an estimate. */
(() => {
  const root = document.querySelector('[data-at]');
  if (!root) return;

  const cfg = JSON.parse(root.dataset.cfg || '{}');
  const EMAIL = root.dataset.helpEmail || 'hello@amoriaofficial.com';
  const form = root.querySelector('[data-at-form]');
  const msg = root.querySelector('[data-at-msg]');
  const btn = root.querySelector('[data-at-submit]');
  const search = root.querySelector('[data-at-search]');
  const out = root.querySelector('[data-at-result]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const mail = `<a href="mailto:${esc(EMAIL)}">${esc(EMAIL)}</a>`;

  /* ---------- Dates: business days skip weekends and US federal holidays ---------- */
  const holCache = {};
  function holidays(y) {
    if (holCache[y]) return holCache[y];
    const nth = (m, wd, n) => { const d = new Date(y, m, 1); let c = 0; for (;;) { if (d.getDay() === wd && ++c === n) return d; d.setDate(d.getDate() + 1); } };
    const last = (m, wd) => { const d = new Date(y, m + 1, 0); while (d.getDay() !== wd) d.setDate(d.getDate() - 1); return d; };
    const fixed = (m, day) => { const d = new Date(y, m, day); if (d.getDay() === 6) d.setDate(day - 1); else if (d.getDay() === 0) d.setDate(day + 1); return d; };
    const list = [fixed(0, 1), nth(0, 1, 3), nth(1, 1, 3), last(4, 1), fixed(5, 19), fixed(6, 4), nth(8, 1, 1), nth(9, 1, 2), fixed(10, 11), nth(10, 4, 4), fixed(11, 25)];
    return (holCache[y] = new Set(list.map((d) => d.toDateString())));
  }
  const isBiz = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !holidays(d.getFullYear()).has(d.toDateString());
  function addBiz(date, n) {
    const d = new Date(date); d.setHours(12, 0, 0, 0);
    const step = n < 0 ? -1 : 1; let left = Math.abs(n);
    while (left > 0) { d.setDate(d.getDate() + step); if (isBiz(d)) left--; }
    return d;
  }
  const dayStart = (x) => { const d = new Date(x); d.setHours(0, 0, 0, 0); return d; };
  const f = (d, o) => new Intl.DateTimeFormat('en-US', o).format(new Date(d));
  const day = (d) => f(d, { weekday: 'short', month: 'short', day: 'numeric' });
  const short = (d) => f(d, { month: 'short', day: 'numeric' });
  const longDay = (d) => f(d, { weekday: 'long', month: 'long', day: 'numeric' });
  const stamp = (d) => f(d, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  const sameDay = (a, b) => dayStart(a).getTime() === dayStart(b).getTime();
  const dayRange = (a, b) => (sameDay(a, b) ? day(a) : `${day(a)} – ${day(b)}`);
  function shortRange(a, b) {
    if (sameDay(a, b)) return short(a);
    const A = new Date(a), B = new Date(b);
    return A.getMonth() === B.getMonth() ? `${short(a)}–${B.getDate()}` : `${short(a)} – ${short(b)}`;
  }
  const money = (v) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(+v || 0);

  /* ---------- Icons ---------- */
  const svg = (p) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${p}</svg>`;
  const ICON = {
    bag: svg('<path d="M5.5 8h13l-1 12.5h-11z"/><path d="M9 8V6.8a3 3 0 0 1 6 0V8"/>'),
    box: svg('<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="m3.5 7.5 8.5 4.5 8.5-4.5"/><path d="M12 12v9"/>'),
    truck: svg('<path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 9.5h4.2l2.8 3v3.5h-7"/><circle cx="6.5" cy="17.5" r="1.8" fill="#fff"/><circle cx="17" cy="17.5" r="1.8" fill="#fff"/>'),
    pin: svg('<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>'),
    home: svg('<path d="M4 10.5 12 4l8 6.5V20H4z"/><path d="m9 14.5 2 2 4-4"/>'),
    copy: svg('<rect x="8.5" y="8.5" width="11" height="11" rx="2"/><path d="M15.5 8.5v-2a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2"/>'),
    check: svg('<path d="m5 12.5 4.5 4.5L19 7.5"/>'),
  };
  const PIN_SMALL = svg('<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>');

  /* ---------- What to show for an order ---------- */
  const RANK = { DELIVERED: 5, OUT_FOR_DELIVERY: 4, ATTEMPTED_DELIVERY: 4, FAILURE: 3 };
  const EVENT_TITLE = {
    CONFIRMED: 'Shipment confirmed', PICKED_UP: 'Picked up by the carrier', CARRIER_PICKED_UP: 'Picked up by the carrier',
    IN_TRANSIT: 'In transit', DELAYED: 'Delayed', READY_FOR_PICKUP: 'Ready for pickup', OUT_FOR_DELIVERY: 'Out for delivery',
    ATTEMPTED_DELIVERY: 'Delivery attempted', DELIVERED: 'Delivered', FAILURE: 'Delivery problem',
  };

  function build(o, now = new Date()) {
    const placed = new Date(o.order.createdAt);
    const first = o.order.firstName ? `, ${o.order.firstName}` : '';
    const dest = o.destination || {};
    const city = [dest.city, dest.province].filter(Boolean).join(', ');
    const items = o.items || [];
    const ships = (o.shipments || []).slice().sort((a, b) => new Date(a.shippedAt) - new Date(b.shippedAt));
    const shippedQty = {};
    ships.forEach((s) => (s.items || []).forEach((i) => { shippedQty[i.id] = (shippedQty[i.id] || 0) + i.qty; }));
    const waiting = items.map((i) => ({ ...i, qty: i.qty - (i.refundedQty || 0) - (shippedQty[i.id] || 0) })).filter((i) => i.qty > 0);
    const refunds = o.refunds || [];
    const refundSum = refunds.reduce((s, r) => s + (+r.amount || 0), 0);
    const lastRefund = refunds[refunds.length - 1];
    const today = dayStart(now);

    const v = { key: '', headline: '', sub: '', eta: null, note: null, step: -1, stepFlag: '', stepNames: {}, stepDates: {}, map: '', city, ships, waiting, updates: [] };
    const ups = [{ t: 'Order placed', x: 'We received your order.', at: placed }];

    // Canceled or fully refunded: no progress bar, no map.
    if (o.order.cancelledAt || o.order.financialStatus === 'REFUNDED') {
      const canceled = !!o.order.cancelledAt;
      v.key = canceled ? 'canceled' : 'refunded';
      v.headline = canceled ? 'Order canceled' : 'Order refunded';
      v.sub = canceled ? `This order was canceled on ${longDay(o.order.cancelledAt)}.` : 'This order has been fully refunded.';
      if (lastRefund) v.sub += ` A refund of ${money(refundSum)} was issued on ${longDay(lastRefund.createdAt)}.`;
      if (canceled) ups.push({ t: 'Order canceled', x: 'Nothing from this order will be shipped.', at: new Date(o.order.cancelledAt) });
      refunds.forEach((r) => ups.push({ t: 'Refund issued', x: `${money(r.amount)} back to your original payment method.`, at: new Date(r.createdAt) }));
      ships.forEach((s) => ups.push({ t: 'Shipped', x: `Your order was sent to ${city}.`, at: new Date(s.shippedAt) }));
      v.updates = ups.sort((a, b) => b.at - a.at);
      return v;
    }

    const est = (from, to, label, note) => ({ from, to, label: label || 'Estimated delivery', note });
    ups.push({ t: 'Preparing your order', x: 'We started getting your order ready to ship.', at: new Date(placed.getTime() + 1), dateOnly: true });

    if (!ships.length) {
      const minsIn = (now - placed) / 60000;
      if (minsIn < cfg.changeMins) {
        const left = Math.max(1, Math.ceil(cfg.changeMins - minsIn));
        v.key = 'received'; v.step = 0;
        v.headline = 'Order received';
        v.sub = `Thank you${first}! We have your order and will start preparing it right away.`;
        v.note = { tone: 'warn', html: `<p>Need to change something? Email us at ${mail} within the next ${left} minute${left === 1 ? '' : 's'}.</p>` };
        v.eta = est(addBiz(placed, cfg.pMin + cfg.dMin), addBiz(placed, cfg.pMax + cfg.dMax), null, 'Based on our usual preparing and shipping times.');
        ups.splice(1, 1);
      } else {
        v.key = 'preparing'; v.step = 1;
        v.headline = 'Preparing your order';
        v.sub = "We're getting your order ready to ship. Your tracking number will show here as soon as it's on its way.";
        // Once the usual preparing time has passed, the estimate simply counts from today.
        const base = today <= dayStart(addBiz(placed, cfg.pMax)) ? placed : addBiz(today, -cfg.pMin);
        v.eta = est(addBiz(base, cfg.pMin + cfg.dMin), addBiz(base, cfg.pMax + cfg.dMax), null, 'Based on our usual preparing and shipping times.');
      }
      v.map = city ? `Delivering to ${city}` : '';
      v.updates = finishUpdates(ups, v);
      return v;
    }

    // Shipped (all of it, or part of it). Progress follows the package that is furthest behind.
    const main = ships.reduce((a, b) => ((RANK[b.status] || 3) < (RANK[a.status] || 3) ? b : a));
    const shipAt = new Date(main.shippedAt);
    v.stepDates[2] = short(ships[0].shippedAt);
    ships.forEach((s, i) => {
      const many = ships.length > 1 || waiting.length;
      ups.push({ t: 'Shipped', x: many ? `Package ${i + 1} is on its way to ${city}.` : `Your order is on its way to ${city}.`, at: new Date(s.shippedAt) });
      (s.events || []).forEach((e) => {
        if (!EVENT_TITLE[e.status]) return;
        const where = [e.city, e.province].filter(Boolean).join(', ');
        ups.push({ t: EVENT_TITLE[e.status], x: where ? (e.status === 'DELIVERED' ? `Delivered in ${where}.` : `Your package is in ${where}.`) : '', at: new Date(e.at) });
      });
      if (s.deliveredAt && !(s.events || []).some((e) => e.status === 'DELIVERED')) ups.push({ t: 'Delivered', x: `Delivered to ${city}.`, at: new Date(s.deliveredAt) });
    });

    const from = main.estimatedDeliveryAt ? new Date(main.estimatedDeliveryAt) : addBiz(shipAt, cfg.dMin);
    const to = main.estimatedDeliveryAt ? new Date(main.estimatedDeliveryAt) : addBiz(shipAt, cfg.dMax);
    const longest = main.estimatedDeliveryAt ? addBiz(main.estimatedDeliveryAt, cfg.dLong - cfg.dMax) : addBiz(shipAt, cfg.dLong);
    const etaNote = main.estimatedDeliveryAt ? 'Estimate from the carrier.' : `Most orders arrive ${cfg.dMin}–${cfg.dMax} business days after shipping.`;
    const lastEvent = (st) => (main.events || []).filter((e) => e.status === st).map((e) => new Date(e.at)).sort((a, b) => b - a)[0];

    if (main.status === 'DELIVERED' || main.deliveredAt) {
      const at = main.deliveredAt || lastEvent('DELIVERED') || now;
      v.key = 'delivered'; v.step = 5;
      v.headline = 'Delivered';
      v.sub = `Delivered on ${longDay(at)}. We hope you love it${first}.`;
      v.note = { tone: 'soft', html: `<p>Not quite right? You have 45 days from delivery to return it. Email us at ${mail} and we'll help.</p>` };
      v.stepDates[3] = ''; v.stepDates[4] = short(at);
      v.map = city ? `Delivered to ${city}` : '';
    } else if (main.status === 'OUT_FOR_DELIVERY') {
      const at = lastEvent('OUT_FOR_DELIVERY') || now;
      v.key = 'out'; v.step = 3; v.stepNames[3] = 'Out for delivery';
      v.headline = 'Out for delivery';
      v.sub = 'Your package is with the local driver and should arrive today.';
      v.eta = { label: 'Arriving', text: 'Today', note: '' };
      v.stepDates[3] = short(at);
      v.map = city ? `Arriving today in ${city}` : '';
    } else if (main.status === 'ATTEMPTED_DELIVERY' || main.status === 'FAILURE') {
      const tried = main.status === 'ATTEMPTED_DELIVERY';
      v.key = tried ? 'attempted' : 'problem'; v.step = 3; v.stepFlag = 'warn'; v.stepNames[3] = tried ? 'Attempted' : 'Problem';
      v.headline = tried ? 'Delivery attempted' : 'Delivery problem';
      v.sub = tried ? "The carrier tried to deliver your package but couldn't." : 'The carrier reported a problem with this delivery.';
      const ask = `email us at ${mail} with your order number and we'll sort it out.`;
      v.note = { tone: 'warn', html: `<p>${tried ? `Look for a note from the carrier at your door, or ${ask}` : `Please ${ask}`}</p>` };
      v.map = city ? `On its way to ${city}` : '';
    } else if (today < dayStart(from)) {
      v.key = 'onway'; v.step = 2;
      v.headline = 'On its way';
      v.sub = `Your order shipped on ${longDay(shipAt)}.`;
      v.eta = est(from, to, null, etaNote);
      v.map = city ? `On its way to ${city}` : '';
    } else if (today <= dayStart(to)) {
      v.key = 'arriving'; v.step = 3; v.stepFlag = 'est';
      v.headline = 'Arriving soon';
      v.sub = `Your order shipped on ${longDay(shipAt)} and should reach you in the next few days.`;
      v.eta = est(from, to, null, etaNote);
      v.map = city ? `Arriving soon in ${city}` : '';
    } else {
      // Past the usual window: she keeps seeing "Still on its way" (owner's choice, no "late" message).
      const withinLongest = today <= dayStart(longest);
      v.key = 'still'; v.step = 3; v.stepFlag = 'est';
      v.headline = 'Still on its way';
      v.sub = withinLongest
        ? `Most orders arrive within ${cfg.dMax} business days of shipping, but some take up to ${cfg.dLong}. Yours is still on its way.`
        : `Your order shipped on ${longDay(shipAt)} and is on its way to you.`;
      if (withinLongest) { v.eta = { label: 'Expected by', text: longDay(longest), note: '' }; v.etaDates = [longest, longest]; }
      v.map = city ? `On its way to ${city}` : '';
    }

    if (waiting.length) {
      v.partial = true;
      if (v.key === 'delivered') { v.headline = 'Part of your order has arrived'; v.step = 4; }
      else if (!['attempted', 'problem'].includes(v.key)) v.headline = 'Part of your order is on its way';
      v.sub = 'The rest is still being prepared and will ship separately. Its tracking number will show here once it ships.';
      v.note = v.key === 'delivered' ? null : v.note;
    }

    v.updates = finishUpdates(ups, v);
    return v;
  }

  function finishUpdates(ups, v) {
    const list = ups.sort((a, b) => b.at - a.at);
    const eta = v.eta && v.eta.from ? v.eta : null;
    if (eta) list.unshift({ est: true, t: 'Estimated delivery', x: dayRange(eta.from, eta.to) });
    else if (v.key === 'still' && v.etaDates) list.unshift({ est: true, t: 'Expected delivery', x: `By ${day(v.etaDates[0])}` });
    return list;
  }

  /* ---------- Rendering ---------- */
  const STEPS = [
    { n: 'Ordered', i: 'bag' },
    { n: 'Preparing', i: 'box' },
    { n: 'On its way', i: 'truck' },
    { n: 'Almost there', i: 'pin' },
    { n: 'Delivered', i: 'home' },
  ];

  function stepsHTML(v, o) {
    if (v.step < 0) return '';
    const placed = o.order.createdAt;
    const dates = { 0: short(placed), ...v.stepDates };
    if (v.step < 4 && dates[4] === undefined) {
      if (v.eta && v.eta.from) dates[4] = `Est.\n${shortRange(v.eta.from, v.eta.to)}`;
      else if (v.key === 'still' && v.etaDates) dates[4] = `Est. by\n${short(v.etaDates[0])}`;
    }
    if (v.step < 2) dates[2] = '';
    const li = STEPS.map((s, i) => {
      let cls = i < v.step ? 'is-done' : i === v.step ? 'is-current' : '';
      if (i === v.step && v.stepFlag) cls += ` is-${v.stepFlag}`;
      const state = i < v.step ? 'done' : i === v.step ? (v.stepFlag === 'est' ? 'current, estimated' : 'current step') : 'not yet';
      return `<li class="at__step ${cls}"${i === v.step ? ' aria-current="step"' : ''}>
        <span class="at__dot">${ICON[s.i]}</span>
        <span class="at__step-name">${esc(v.stepNames[i] || s.n)}<span class="at-sr"> (${state})</span></span>
        <span class="at__step-date">${esc(dates[i] || '')}</span>
      </li>`;
    }).join('');
    return `<ol class="at__steps" aria-label="Order progress">${li}</ol>`;
  }

  function imgURL(u) {
    if (!u || !/^https:\/\/cdn\.shopify\.com\//.test(u)) return '';
    return u + (u.includes('?') ? '&' : '?') + 'width=216';
  }

  function itemHTML(i, qty) {
    const opts = (i.options || []).map((x) => (x.name ? `${esc(x.name)}: ${esc(x.value)}` : esc(x.value))).join('<br>');
    const q = qty == null ? i.qty : qty;
    const paid = i.qty ? (+i.paid / i.qty) * q : 0;
    const full = (+i.price || 0) * q;
    const img = imgURL(i.image);
    const refunded = i.refundedQty ? `<span class="at__tag">${i.refundedQty === i.qty ? 'Refunded' : `${i.refundedQty} refunded`}</span>` : '';
    return `<li class="at__item">
      ${img ? `<img src="${esc(img)}" alt="" width="72" height="96" loading="lazy" decoding="async">` : '<span class="at__item-ph"></span>'}
      <div>
        <p class="at__item-name">${esc(i.title)}</p>
        <p class="at__item-meta">${opts ? `${opts}<br>` : ''}Qty ${q}</p>
        ${refunded}
      </div>
      <div class="at__item-price">${full > paid + 0.004 ? `<s>${money(full)}</s>` : ''}${money(paid)}</div>
    </li>`;
  }

  function itemsHTML(o, v) {
    const byId = Object.fromEntries((o.items || []).map((i) => [i.id, i]));
    const groups = v.ships.length > 1 || (v.partial && v.ships.length);
    let body;
    if (!groups) {
      body = `<ul class="at__items">${(o.items || []).map((i) => itemHTML(i)).join('')}</ul>`;
    } else {
      body = v.ships.map((s, n) => `<div class="at__pkg">
          <p class="at__pkg-head"><strong>Package ${n + 1}</strong><span>${s.deliveredAt ? `Delivered ${short(s.deliveredAt)}` : `Shipped ${short(s.shippedAt)}`}</span></p>
          <ul class="at__items">${(s.items || []).map((x) => (byId[x.id] ? itemHTML(byId[x.id], x.qty) : '')).join('')}</ul>
        </div>`).join('');
      if (v.waiting.length) {
        body += `<div class="at__pkg"><p class="at__pkg-head"><strong>Still being prepared</strong><span>Ships separately</span></p>
          <ul class="at__items">${v.waiting.map((w) => itemHTML(byId[w.id], w.qty)).join('')}</ul></div>`;
      }
    }
    const count = (o.items || []).reduce((s, i) => s + i.qty, 0);
    return `<section class="at__card" aria-labelledby="at-items-h">
      <h3 class="at__h" id="at-items-h">Your order<small>${count} item${count === 1 ? '' : 's'}</small></h3>
      ${body}
      <p class="at__total"><span>Total paid</span><span>${money(o.order.total)}</span></p>
    </section>`;
  }

  function trackingHTML(v) {
    if (['canceled', 'refunded'].includes(v.key)) return '';
    const withNo = v.ships.filter((s) => s.number);
    const rows = withNo.map((s, n) => `<div class="at__track">
        <div>
          <p class="at__track-carrier">${withNo.length > 1 ? `Package ${n + 1} · ` : ''}Tracked shipping</p>
          <p class="at__track-no">${esc(s.number)}</p>
        </div>
        <button type="button" class="at__copy" data-at-copy="${esc(s.number)}">${ICON.copy}<span>Copy</span></button>
      </div>`).join('');
    const body = rows || '<p class="at__muted">Your tracking number will show here as soon as your order ships.</p>';
    return `<section class="at__card" aria-labelledby="at-track-h"><h3 class="at__h" id="at-track-h">Tracking number</h3>${body}</section>`;
  }

  function updatesHTML(v) {
    const li = v.updates.map((u) => `<li class="at__upd${u.est ? ' is-est' : ''}">
        <p class="at__upd-title">${esc(u.t)}</p>
        ${u.x ? `<p class="at__upd-text">${esc(u.x)}</p>` : ''}
        ${u.at ? `<p class="at__upd-time">${esc(u.dateOnly ? longDay(u.at) : stamp(u.at))}</p>` : ''}
      </li>`).join('');
    return `<section class="at__card" aria-labelledby="at-upd-h"><h3 class="at__h" id="at-upd-h">Updates</h3><ol class="at__updates">${li}</ol></section>`;
  }

  function render(o) {
    const v = build(o);
    const d = o.destination || {};
    const hasMap = v.map && isFinite(d.lat) && isFinite(d.lng);
    const eta = v.eta
      ? `<div class="at__eta"><p class="at__eta-label">${esc(v.eta.label)}</p><p class="at__eta-date">${esc(v.eta.text || dayRange(v.eta.from, v.eta.to))}</p>${v.eta.note ? `<p class="at__eta-note">${esc(v.eta.note)}</p>` : ''}</div>`
      : '';
    const note = v.note ? `<div class="at__note at__note--${v.note.tone}">${v.note.html}</div>` : '';

    out.innerHTML = `
      <div class="at__top">
        <p class="at__eyebrow">Order ${esc(o.order.name)} · placed ${esc(short(o.order.createdAt))}</p>
        <button type="button" class="at__link" data-at-again>Track another order</button>
      </div>
      <div class="at__status">
        <div>
          <h2 class="at__headline" tabindex="-1">${esc(v.headline)}</h2>
          <p class="at__sub">${esc(v.sub)}</p>
        </div>
        ${eta}
        ${note}
      </div>
      ${stepsHTML(v, o)}
      <div class="at__grid">
        <div class="at__col">
          ${hasMap ? `<div class="at__map"><div class="at__map-canvas" aria-hidden="true"></div><p class="at__map-chip">${PIN_SMALL}<span>${esc(v.map)}</span></p></div>` : ''}
          ${updatesHTML(v)}
        </div>
        <div class="at__col">
          ${trackingHTML(v)}
          ${itemsHTML(o, v)}
          ${(d.lines || []).length ? `<section class="at__card"><h3 class="at__h">Shipping to</h3><address class="at__addr">${d.lines.map(esc).join('<br>')}</address></section>` : ''}
          <section class="at__card at__help"><h3 class="at__h">Questions about your order?</h3><p>Email us at ${mail} and we'll reply within 24 hours. Please include your order number.</p></section>
        </div>
      </div>
      <p style="text-align:center;margin:32px 0 0"><button type="button" class="at__link" data-at-again>Track another order</button></p>`;

    search.hidden = true;
    out.hidden = false;
    if (hasMap) drawMap(out.querySelector('.at__map-canvas'), d);
    const top = root.getBoundingClientRect().top + scrollY - 90;
    if (scrollY > top) scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
    out.querySelector('.at__headline').focus({ preventScroll: true });
  }

  /* ---------- Map (MapLibre from our theme files + OpenFreeMap tiles; loads only after a result) ---------- */
  let libPromise, map;
  function loadLib() {
    if (libPromise) return libPromise;
    libPromise = new Promise((res, rej) => {
      const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = root.dataset.mapCss; document.head.appendChild(l);
      const s = document.createElement('script'); s.src = root.dataset.mapJs; s.async = true;
      s.onload = () => (window.maplibregl ? res(window.maplibregl) : rej()); s.onerror = rej;
      document.head.appendChild(s);
    });
    return libPromise;
  }
  const hasWebGL2 = () => { try { return !!document.createElement('canvas').getContext('webgl2'); } catch (e) { return false; } };

  // Flat map from plain image tiles: works on every phone, no WebGL needed.
  function staticMap(el, d) {
    if (map) { try { map.remove(); } catch (e) { /* already gone */ } map = null; }
    el.innerHTML = '';
    const z = 11, n = 2 ** z, rad = (d.lat * Math.PI) / 180;
    const px = ((d.lng + 180) / 360) * n * 256;
    const py = ((1 - Math.log(Math.tan(rad) + 1 / Math.cos(rad)) / Math.PI) / 2) * n * 256;
    const W = el.clientWidth || 340, H = el.clientHeight || 234;
    const left = px - W / 2, top = py - H / 2;
    const box = document.createElement('div'); box.className = 'at__smap';
    for (let ty = Math.floor(top / 256); ty <= Math.floor((top + H) / 256); ty++) {
      if (ty < 0 || ty >= n) continue;
      for (let tx = Math.floor(left / 256); tx <= Math.floor((left + W) / 256); tx++) {
        const img = new Image(256, 256); img.alt = ''; img.decoding = 'async';
        img.src = `https://tile.openstreetmap.org/${z}/${((tx % n) + n) % n}/${ty}.png`;
        img.style.left = `${Math.round(tx * 256 - left)}px`; img.style.top = `${Math.round(ty * 256 - top)}px`;
        box.appendChild(img);
      }
    }
    const pin = document.createElement('div'); pin.className = 'at__pin'; box.appendChild(pin);
    const attr = document.createElement('a'); attr.className = 'at__smap-attr'; attr.href = 'https://www.openstreetmap.org/copyright';
    attr.target = '_blank'; attr.rel = 'noopener'; attr.textContent = '© OpenStreetMap'; box.appendChild(attr);
    el.appendChild(box);
  }

  // Full map when the phone can run it; flat map if it can't, fails, or takes longer than 8 s.
  async function drawMap(el, d) {
    if (!hasWebGL2() || window.__atStaticMap) { staticMap(el, d); return; }
    let done = false;
    const fallback = () => { if (done) return; done = true; if (el.isConnected) staticMap(el, d); };
    const timer = setTimeout(fallback, 8000);
    try {
      const ml = await loadLib();
      if (done || !el.isConnected) return;
      if (map) { map.remove(); map = null; }
      map = new ml.Map({ container: el, style: 'https://tiles.openfreemap.org/styles/positron', center: [d.lng, d.lat], zoom: 10.3, interactive: false, attributionControl: { compact: true } });
      const pin = document.createElement('div'); pin.className = 'at__pin';
      new ml.Marker({ element: pin }).setLngLat([d.lng, d.lat]).addTo(map);
      map.on('error', () => { if (!done && map && !map.isStyleLoaded()) { clearTimeout(timer); fallback(); } });
      map.on('load', () => {
        if (done) return;
        done = true; clearTimeout(timer);
        el.querySelectorAll('.maplibregl-compact-show').forEach((a) => a.classList.remove('maplibregl-compact-show'));
        map.getStyle().layers.forEach((L) => {
          try {
            if (L.type === 'background') map.setPaintProperty(L.id, 'background-color', '#f4f2ee');
            else if (L.type === 'fill' && /water/.test(L.id)) map.setPaintProperty(L.id, 'fill-color', '#dce3e4');
            else if (L.type === 'fill' && /park|wood|grass|landcover/.test(L.id)) map.setPaintProperty(L.id, 'fill-color', '#e8eae0');
          } catch (e) { /* layer without that paint property */ }
        });
      });
    } catch (e) {
      clearTimeout(timer); fallback();
    }
  }

  /* ---------- Form ---------- */
  const MSG = {
    notfound: () => `<strong>We couldn't find that order.</strong><p>Check that the order number matches your confirmation email, and use the email you ordered with.</p><p>Still stuck? Email us at ${mail} and we'll look it up for you.</p>`,
    toomany: () => `<strong>Too many tries in a row.</strong><p>To keep orders private, please wait a minute and try again.</p><p>Or email us at ${mail} and we'll look it up for you.</p>`,
    error: () => `<strong>We couldn't load your order just now.</strong><p>Please check your internet connection and try again in a moment.</p>`,
  };
  function showMsg(k) { msg.innerHTML = MSG[k](); msg.hidden = false; msg.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' }); }
  function clearErrors() {
    msg.hidden = true;
    form.querySelectorAll('.at__ferr').forEach((e) => e.remove());
    form.querySelectorAll('[aria-invalid]').forEach((e) => { e.removeAttribute('aria-invalid'); e.setAttribute('aria-describedby', e.id.replace(/^(at-\w+)-/, '$1-hint-')); });
  }
  function fieldErr(input, text) {
    input.setAttribute('aria-invalid', 'true');
    const p = document.createElement('p'); p.className = 'at__ferr'; p.id = `${input.id}-err`; p.textContent = text;
    input.insertAdjacentElement('afterend', p);
    input.setAttribute('aria-describedby', p.id);
  }
  function setLoading(on) {
    btn.disabled = on;
    form.querySelectorAll('input').forEach((i) => { i.readOnly = on; });
    form.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.innerHTML = on ? '<span class="at__spin" aria-hidden="true"></span><span>Finding your order…</span>' : '<span>Track my order</span>';
  }
  const normOrder = (s) => { const v = String(s || '').replace(/\s+/g, '').replace(/^#+/, ''); return /^[A-Za-z0-9-]{1,20}$/.test(v) ? v : ''; };
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (btn.disabled) return;
    clearErrors();
    const rawOrder = form.order.value.trim();
    const order = normOrder(rawOrder);
    const email = form.email.value.trim();
    let bad = null;
    if (!order) { fieldErr(form.order, rawOrder ? 'Use the number from your confirmation email, for example #1037.' : 'Enter your order number, for example #1037.'); bad = bad || form.order; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { fieldErr(form.email, email ? 'Check your email. It should look like name@example.com.' : 'Enter the email you used at checkout.'); bad = bad || form.email; }
    if (bad) { bad.focus(); return; }

    setLoading(true);
    try {
      const [res] = await Promise.all([
        fetch(root.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ order, email }), credentials: 'same-origin' }),
        wait(400),
      ]);
      let data = null;
      try { data = await res.json(); } catch (_) { /* not our lookup answering */ }
      if (res.ok && data && data.order) render(data);
      else if (res.status === 429 || (data && data.error === 'rate_limited')) showMsg('toomany');
      else if (data && data.error === 'not_found') showMsg('notfound');
      else showMsg('error');
    } catch (_) {
      showMsg('error');
    } finally {
      setLoading(false);
    }
  });

  root.addEventListener('click', async (e) => {
    const again = e.target.closest('[data-at-again]');
    if (again) {
      if (map) { map.remove(); map = null; }
      out.hidden = true; out.innerHTML = ''; search.hidden = false; clearErrors();
      form.order.value = ''; form.order.focus();
      return;
    }
    const copy = e.target.closest('[data-at-copy]');
    if (copy) {
      const text = copy.dataset.atCopy;
      try { await navigator.clipboard.writeText(text); } catch (_) {
        const t = document.createElement('textarea'); t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (__) { /* nothing else to try */ } t.remove();
      }
      copy.innerHTML = `${ICON.check}<span>Copied</span>`;
      setTimeout(() => { copy.innerHTML = `${ICON.copy}<span>Copy</span>`; }, 2000);
    }
  });

  const pre = new URLSearchParams(location.search).get('order');
  if (pre && normOrder(pre)) form.order.value = `#${normOrder(pre)}`;

  /* ---------- Demo states (only when switched on in the section settings) ---------- */
  const demoBox = root.querySelector('[data-at-demo]');
  if (demoBox) {
    const IMG = {
      heritage: 'https://cdn.shopify.com/s/files/1/1034/0646/9467/files/hf_20260915_091421_a0da003c-55b9-4d7c-9b2f-6b982a0026c4.png?v=1789478176',
      puffer: 'https://cdn.shopify.com/s/files/1/1034/0646/9467/files/hf_20260909_062025_794955b6-29f2-4bda-8565-ff93a172b2e3.png?v=1788940896',
    };
    const iso = (d) => new Date(d).toISOString();
    const H = 36e5, D = 864e5;
    const bizAgo = (n, hour = 11) => { const d = addBiz(new Date(), -n); d.setHours(hour, 20, 0, 0); return d; };
    function order(over = {}) {
      const base = {
        order: { name: '#1042', createdAt: iso(Date.now() - 2 * D), cancelledAt: null, financialStatus: 'PAID', total: '178.98', currency: 'USD', firstName: 'Linda' },
        destination: { city: 'Rockford', province: 'IL', lat: 42.27, lng: -89.09, lines: ['Linda M.', '48•• Spring Creek Rd', 'Rockford, IL 611••'] },
        items: [
          { id: '1', title: 'Heritage Knit Cardigan', options: [{ name: 'Color', value: 'Burgundy Grove' }, { name: 'Size', value: 'M' }], qty: 2, refundedQty: 0, price: '54.99', paid: '98.99', image: IMG.heritage },
          { id: '2', title: 'Fleece-Lined Puffer Coat', options: [{ name: 'Color', value: 'Dark Green' }, { name: 'Size', value: 'M' }], qty: 1, refundedQty: 0, price: '79.99', paid: '79.99', image: IMG.puffer },
        ],
        shipments: [],
        refunds: [],
      };
      return { ...base, ...over, order: { ...base.order, ...(over.order || {}) } };
    }
    const ship = (shipped, extra = {}) => ({ status: 'IN_TRANSIT', shippedAt: iso(shipped), number: '1Z84A9R70392815546', items: [{ id: '1', qty: 2 }, { id: '2', qty: 1 }], events: [], ...extra });
    const shippedOrder = (shipped, extra) => order({ order: { createdAt: iso(addBiz(shipped, -2)) }, shipments: [ship(shipped, extra)] });

    const STATES = {
      'Order received': () => order({ order: { createdAt: iso(Date.now() - 8 * 60000) } }),
      Preparing: () => order({ order: { createdAt: iso(Date.now() - 3 * H) } }),
      'On its way': () => shippedOrder(bizAgo(1)),
      'Arriving soon': () => shippedOrder(bizAgo(cfg.dMin)),
      'Still on its way': () => shippedOrder(bizAgo(cfg.dMax + 2)),
      'Still on its way (after 12 days)': () => shippedOrder(bizAgo(cfg.dLong + 2)),
      'Out for delivery*': () => shippedOrder(bizAgo(4), { status: 'OUT_FOR_DELIVERY', events: [{ status: 'IN_TRANSIT', at: iso(Date.now() - 26 * H), city: 'Chicago', province: 'IL' }, { status: 'OUT_FOR_DELIVERY', at: iso(Date.now() - 3 * H), city: 'Rockford', province: 'IL' }] }),
      'Delivered*': () => shippedOrder(bizAgo(5), { status: 'DELIVERED', deliveredAt: iso(Date.now() - 20 * H) }),
      'Delivery attempted*': () => shippedOrder(bizAgo(5), { status: 'ATTEMPTED_DELIVERY', events: [{ status: 'ATTEMPTED_DELIVERY', at: iso(Date.now() - 5 * H), city: 'Rockford', province: 'IL' }] }),
      'Partly shipped': () => order({ order: { createdAt: iso(bizAgo(3)) }, shipments: [ship(bizAgo(1), { items: [{ id: '1', qty: 2 }] })] }),
      Canceled: () => order({ order: { createdAt: iso(Date.now() - 5 * H), cancelledAt: iso(Date.now() - 4 * H), financialStatus: 'REFUNDED' }, refunds: [{ createdAt: iso(Date.now() - 4 * H), amount: '178.98' }] }),
      Refunded: () => order({ order: { createdAt: iso(bizAgo(20)), financialStatus: 'REFUNDED' }, shipments: [ship(bizAgo(18), { status: 'DELIVERED', deliveredAt: iso(bizAgo(12)) })], refunds: [{ createdAt: iso(bizAgo(2)), amount: '178.98' }], items: order().items.map((i) => ({ ...i, refundedQty: i.qty })) }),
      'Not found': 'notfound',
      'Too many tries': 'toomany',
      'Connection problem': 'error',
      Loading: 'loading',
    };
    const wrap = demoBox.querySelector('div');
    wrap.innerHTML = Object.keys(STATES).map((k) => `<button type="button" aria-pressed="false">${esc(k)}</button>`).join('');
    demoBox.querySelector('p').textContent += ' * = only shown when Shopify itself confirms it.';
    wrap.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      wrap.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      const s = STATES[b.textContent];
      setLoading(false); clearErrors();
      if (typeof s === 'function') { render(s()); return; }
      if (map) { map.remove(); map = null; }
      out.hidden = true; search.hidden = false;
      form.order.value = '#1042'; form.email.value = 'linda@example.com';
      if (s === 'loading') setLoading(true); else showMsg(s);
    });
  }
})();
